import script from "./add-category-dialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./add-category-dialog.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__